import axios from 'axios';

// 保存部门
export function saveConfig(data) {
  return axios({
    url: '/fyOpinion/saveConfig',
    method: 'POST',
    data: data,
  });
}

// 删除部门
export function delConfig(data) {
  return axios({
    url: '/fyOpinion/delConfig',
    method: 'POST',
    data: data,
  });
}

// 保存部门绑定的教师
export function addBindingTeacher(data) {
  return axios({
    url: '/fyOpinion/addBindingTeacher',
    method: 'POST',
    data: data,
  });
}

// 获取部门绑定的教师id集合
export function getBindingTeacherIds(params) {
  return axios({
    url: '/fyOpinion/getBindingTeacherIds',
    method: 'GET',
    params: params,
  });
}
